import Vue from 'vue';
import * as authn from '@byuweb/browser-oauth';
// @ts-ignore
import dynamicImportPolyfill from 'dynamic-import-polyfill';
import { isEqual } from 'lodash';
const AuthRefreshRequired = Vue.extend({
    props: {
        failDuringPost: Boolean,
    },
    methods: {
        popupAuth() {
            authn.refresh('popup');
            this.$emit('submit');
        },
    },
    // Template compilation doesn't work at runtime in our standard BYU builds, so we
    // manually do the `render` function instead of a `template`
    // ADDENDUM: Sigh, even the Vuetify elements ("v-card", "v-card-title", etc.) do not
    // compile, so we have to manually generate them as well
    render(h) {
        return h('div', { staticClass: 'v-card v-sheet theme--light' }, [
            h('div', { staticClass: 'v-card__title headline warning white--text' }, 'Re-authentication Required'),
            h('div', { staticClass: 'v-card__text' }, [
                'CAS Authentication has expired.',
                h('br'),
                h('br'),
                'Click this "Re-authenticate" button. You will log in through a separate tab and then immediately return to this page.',
                this.failDuringPost
                    ? h('div', [h('br'), 'If you were in the middle of saving data, you may have to click "Save" again.'])
                    : '',
            ]),
            h('div', { staticClass: 'v-card__actions' }, [
                h('button', {
                    staticClass: 'v-btn v-btn--contained theme--light v-size--large primary',
                    on: {
                        click: ($event) => {
                            $event.stopPropagation();
                            // @ts-ignore
                            return this.popupAuth($event);
                        },
                    },
                }, [h('span', { staticClass: 'v-btn__content' }, 'Re-authenticate')]),
            ]),
        ]);
    },
});
export default (context) => {
    context.$dialog.component('authRefreshRequired', AuthRefreshRequired);
    const oAuthConfig = Object.assign({
        autoRefreshOnTimeout: true,
        logoutRedirect: 'https://www.byu.edu',
        clientId: process.env.NUXT_ENV_OAUTH_CLIENT_ID,
        callbackUrl: process.env.NUXT_ENV_OAUTH_CALLBACK_URL,
        baseUrl: process.env.NUXT_ENV_API_SERVER,
    }, context.env.oAuth);
    if (!oAuthConfig.clientId) {
        // $dialog isn't fully configured when this code runs, so setTimeout bumps this call to the end of the event queue
        setTimeout(() => context.$dialog.error({
            title: 'Configuration Error',
            text: 'This site is not configured correctly',
            persistent: true,
        }));
        console.error('OAuth environment variables (NUXT_ENV_OAUTH_CLIENT_ID, NUXT_ENV_OAUTH_CALLBACK_URL) not set');
        return;
    }
    if ('') {
        oAuthConfig.baseUrl = '';
    }
    let providerUrl = '';
    if ('') {
        providerUrl = '';
    }
    else if ('true') {
        providerUrl = 'https://cdn.byu.edu/browser-oauth-pkce/latest/pkce-grant.min.js';
    }
    else if ('') {
        providerUrl = 'https://cdn.byu.edu/browser-oauth-implicit/experimental/pkce-shim/implicit-grant.min.js';
    }
    else {
        providerUrl = 'https://cdn.byu.edu/browser-oauth-implicit/latest/implicit-grant.min.js';
    }
    // TODO: If Edge ever natively supports dynamic imports (i.e. "import(xxx)" returns a Promise), then use native
    dynamicImportPolyfill.initialize();
    __import__(/* webpackIgnore: true */ providerUrl).then((implicit) => implicit.configure(oAuthConfig));
    // External library, so we cannot avoid "new" constructor
    // eslint-disable-next-line no-new
    new authn.AuthenticationObserver(({ state, token, user }) => {
        // Ignore HASH of current path, just get path + query
        const currentPath = {
            path: context.route.path,
            query: context.route.query,
        };
        switch (state) {
            case authn.STATE_UNAUTHENTICATED:
                window.sessionStorage.setItem('sitePreauthPath', JSON.stringify(currentPath));
                if (!process.env.NUXT_ENV_OAUTH_DISABLE_AUTO_LOGIN) {
                    authn.login();
                }
                break;
            case authn.STATE_ERROR:
                context.$dialog.authRefreshRequired({ persistent: true });
                break;
            case authn.STATE_AUTHENTICATED: {
                context.$axios.setToken(token.authorizationHeader);
                context.store.dispatch('authenticate', user);
                const prePathString = window.sessionStorage.getItem('sitePreauthPath');
                window.sessionStorage.removeItem('sitePreauthPath');
                if (prePathString) {
                    try {
                        const prePath = JSON.parse(prePathString);
                        if (!isEqual(prePath, currentPath) && prePath.path) {
                            context.redirect(prePath.path, prePath.query);
                        }
                    }
                    catch (e) {
                        // Intentionally ignoring. If the stored path is malformed JSON, then just stay where we are
                    }
                }
            }
        }
    });
};
//# sourceMappingURL=implicit-grant.js.map